<template>
    <div>
      <h1>Produits chimiques Mazal - Dashboard</h1>
    </div>
  </template>
  
  <script setup>
  </script>